module.exports = __webpack_public_path__ + "img/jon_TF_book.a296b62e.png";